export var defaultProps = {
    className: '',
    style: undefined,
    form: {},
    labelPosition: 'Right',
    formGroupTitle: '',
    onFinish: function (obj) { },
    onFinishFailed: function (value) { },
    starPositon: 'Left',
};
export var formFieldProps = {
    name: '',
    label: '',
    className: '',
    rules: [{ required: false, message: '' }],
    disabled: false,
};
